













































import Vue from 'vue'

import { GetTherapists, ActiveTherapies } from './AssignTherapist.graphql'
import { GetTherapistsQuery } from '@/graphql-schema'
import { CaseWithMessages } from '@/queries/cases.graphql'
import { runInThisContext } from 'vm'
import treatment from '@/routing/treatment'

export default Vue.extend({
  apollo: {
    therapists: {
      query: GetTherapists,
    },
    pickedCase: {
      query: CaseWithMessages,
      fetchPolicy: 'no-cache',
      variables() {
        return {
          id: this.caseId,
        }
      },
    },
    allActiveTherapiesForTherapists: {
      query: ActiveTherapies,
      fetchPolicy: 'no-cache',
    },
  },
  data(): {
    therapistId: string | null
    therapists: GetTherapistsQuery['therapists']
    openModal: boolean
  } {
    return {
      therapistId: null,
      therapists: { nodes: [] },
      openModal: false,
    }
  },
  computed: {
    options(): any[] {
      const therapists = this.therapists?.nodes || []
      return therapists.map((t) => ({ value: t.id, text: t.username }))
    },
    diagnosis(): string {
      if (this.pickedCase != null) {
        return this.pickedCase.diagnosis
      }
      return ''
    },
    interviewerName(): string {
      if (this.pickedCase?.members?.nodes.length > 0) {
        let member = this.pickedCase?.members?.nodes.find(member => member.actsAsInterviewer)
        return member.alias
      }
      return ''
    },
    isWaitList(): boolean {
      let firstItem =
        this.pickedCase?.treatmentAssignments?.nodes.find(
          treatment => treatment.treatment === 'wait'
        ) || null
      return firstItem != null
    },
    isTherapyListAvailable(): boolean {
      return this.allActiveTherapiesForTherapists?.nodes?.length > 0 || false
    },
    activeTherapists(): any[] {
      if (this.allActiveTherapiesForTherapists) {
        return this.allActiveTherapiesForTherapists?.nodes || []
      }
      return []
    },
  },
  props: {
    value: {
      required: true,
      type: Object,
    },
    condition: {
      type: String,
      required: true,
    },
    caseId: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.openModal = true
  },
})
